import { Box, HStack, Spinner, Text, VStack } from "@chakra-ui/react";
import React from "react";
import { HiOutlinePlay, HiOutlineTrash } from "react-icons/hi2";

import { IconButton } from "../../../../components";
import { formatBytes } from "../IntroMediaUpload.utils";
import { FileIcon } from "./FileIcon";
import { disabledButtonStyles } from "./styles";

type ProcessingContentProps = {
  fileName: string;
  fileType: string;
  fileSizeBytes?: number;
  readOnly?: boolean;
};

export const ProcessingContent: React.FC<ProcessingContentProps> = ({
  fileName,
  fileType,
  fileSizeBytes,
  readOnly,
}) => (
  <HStack justify="space-between" spacing={6} align="flex-start" width="100%">
    <HStack spacing={4} align="flex-start" flex="1" minW={0}>
      <FileIcon fileType={fileType} size="sm" />
      <VStack align="start" spacing={1} flex="1" minW={0}>
        <Box maxW="100%" overflow="hidden">
          <Text
            fontSize="sm"
            fontWeight="semibold"
            color="gray.900"
            lineHeight={5}
            display="inline"
            noOfLines={1}
          >
            {fileName}
            {fileSizeBytes && (
              <Text as="span" fontWeight="normal" color="gray.600">
                {" "}
                • {formatBytes(fileSizeBytes)}
              </Text>
            )}
          </Text>
        </Box>
        <HStack spacing={2} py={1}>
          <Spinner size="sm" color="blue.600" />
          <Text fontSize="sm" color="blue.600" lineHeight={5}>
            Processing...
          </Text>
        </HStack>
      </VStack>
    </HStack>
    {!readOnly && (
      <VStack spacing={2} align="center" justify="center" flexShrink={0}>
        <IconButton
          aria-label="Play"
          icon={<HiOutlinePlay size={16} />}
          {...disabledButtonStyles}
          size="xs"
          borderRadius="sm"
          minW={6}
          width={6}
          height={6}
          p={1}
          isDisabled
        />
        <IconButton
          aria-label="Remove"
          icon={<HiOutlineTrash size={16} />}
          {...disabledButtonStyles}
          size="xs"
          borderRadius="sm"
          minW={6}
          width={6}
          height={6}
          p={1}
          isDisabled
        />
      </VStack>
    )}
  </HStack>
);
